import { render, staticRenderFns } from "./Molecular.vue?vue&type=template&id=c0f243be&scoped=true&lang=pug&"
import script from "./Molecular.vue?vue&type=script&lang=js&"
export * from "./Molecular.vue?vue&type=script&lang=js&"
import style0 from "./Molecular.vue?vue&type=style&index=0&id=c0f243be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f243be",
  null
  
)

export default component.exports